"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1304],{

/***/ 61304:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ v2_Filter; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./public/icons/print.svg
var icons_print = __webpack_require__(30402);
// EXTERNAL MODULE: ./public/icons/share.svg
var icons_share = __webpack_require__(66773);
// EXTERNAL MODULE: ./public/icons/close-filter.svg
var close_filter = __webpack_require__(8327);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./src/components/core/Checkbox/Checkbox.jsx
var Checkbox = __webpack_require__(55511);
// EXTERNAL MODULE: ./src/components/core/RadioButton/RadioButton.jsx
var RadioButton = __webpack_require__(94593);
// EXTERNAL MODULE: ./src/hooks/useWindowResize.js
var useWindowResize = __webpack_require__(18216);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./src/components/core/Collapsible/index.js
var Collapsible = __webpack_require__(73394);
// EXTERNAL MODULE: ./utils/helper.js
var helper = __webpack_require__(27514);
;// CONCATENATED MODULE: ./src/components/ProductList/v2/Filter/helper.js

const setUrlParams = function(filters, isReplace, type, facetLabels, resetTitle) {
    let clearAllFilters = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : ()=>{};
    let query = window.location.search;
    if (query.length && !query.includes("tab") && type) query += isReplace ? "" : "".concat(query.includes("?") ? "&" : "?", "tab=").concat(type);
    if (filters.length > 0) {
        query += query ? "&" : "";
        filters.forEach((filter, i)=>{
            var ref;
            const values = [
                ...filter.value
            ];
            const searches = location.search.split("&");
            const index = searches.findIndex((search)=>search.includes(filter.facet));
            if (index > -1) {
                searches.splice(index, 1);
                query = searches.join("&");
                query += query ? "&" : "";
            }
            if (values.length !== 0 && filter.facet === "Price_Range" ? true : facetLabels[(ref = filter.facet) === null || ref === void 0 ? void 0 : ref.replace(/^\*{2}/, "")]) {
                var ref1, ref2;
                var ref3;
                query += "".concat(filter.facet === "Price_Range" ? filter.facet : (ref3 = (ref2 = facetLabels[(ref1 = filter.facet) === null || ref1 === void 0 ? void 0 : ref1.replace(/^\*{2}/, "")]) === null || ref2 === void 0 ? void 0 : ref2.replace(/ /g, "_")) !== null && ref3 !== void 0 ? ref3 : filter.facet, "=").concat(filter.facet === "Price_Range" ? filter.value : encodeURIComponent(values)).concat(i !== filters.length - 1 ? "&" : "");
            }
        });
        if (resetTitle) resetTitle();
    } else {
        clearAllFilters(false);
    }
    const queryStr = query.toString();
    const queryParam = queryStr.length === 0 ? window.location.pathname : queryStr.includes("?") ? queryStr : "?".concat(queryStr);
    query && window.history.replaceState(window.location.pathname, document.title, queryParam);
    if (type) (0,helper/* retainSearchQueryParams */.mSA)(type);
};
const getAppliedFiltersForAnalytics = (appliedFilters, facetLabels)=>{
    const filterArray = [];
    appliedFilters.forEach((filter)=>{
        filter.display.forEach((filtervalue)=>{
            filterArray.push("".concat((0,helper/* formatFacetName */.n4H)(filter.facet, null, facetLabels), ":").concat(filtervalue));
        });
    });
    return filterArray.length ? filterArray.join("|") : "";
};


;// CONCATENATED MODULE: ./src/components/ProductList/v2/Filter/filterAnalytics.js


const getShowHideFilterOptionAnalyticsData = function(collapse, facet, facetName, page) {
    let selectedTab = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : "products";
    let analyticsData = JSON.stringify({
        eventAction: "plp filter ".concat(collapse[facet] ? "expand" : "collapse"),
        eventName: "plp filter ".concat(collapse[facet] ? "expand" : "collapse"),
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: collapse[facet] ? "expand" : "collapse",
        internalLinkPosition: "plp",
        internalLinkType: "plp:" + facetName,
        internalLinkZoneName: "plp:filters",
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    });
    if (page === "search") {
        analyticsData = JSON.stringify({
            eventAction: "search results:".concat(selectedTab, ":filters ").concat(collapse[facet] ? "expand" : "collapse"),
            eventName: "search results:".concat(selectedTab, ":filters ").concat(collapse[facet] ? "expand" : "collapse"),
            eventType: "navigation",
            eventMsg: "n/a",
            eventStatus: "n/a",
            internalLinkName: collapse[facet] ? "expand" : "collapse",
            internalLinkPosition: "search results",
            internalLinkType: "search results:" + facetName,
            internalLinkZoneName: "search results:".concat(selectedTab, ":filters"),
            internalLinkURL: "n/a",
            clickInternalLinks: "true"
        });
    } else if (page === "literature") {
        analyticsData = JSON.stringify({
            eventAction: "literature :filters ".concat(collapse[facet] ? "expand" : "collapse"),
            eventName: "literature :filters ".concat(collapse[facet] ? "expand" : "collapse"),
            eventType: "navigation",
            eventMsg: "n/a",
            eventStatus: "n/a",
            internalLinkName: collapse[facet] ? "expand" : "collapse",
            internalLinkPosition: "literature",
            internalLinkType: "literature:" + facetName,
            internalLinkZoneName: "literature :filters",
            internalLinkURL: "n/a",
            clickInternalLinks: "true"
        });
    }
    return analyticsData;
};
const getFilterOptionsAnalyticsData = (param)=>{
    let { obj , appliedFilters , facetLabels , facetName , isSelected , page , selectedTab  } = param;
    const getAppliedFiltersForPlpAnalyticsData = (objDisplay)=>{
        const dataLayerFilterArray = [];
        appliedFilters.forEach((filter)=>{
            filter.display.forEach((filtervalue)=>{
                dataLayerFilterArray.push("".concat((0,helper/* formatFacetName */.n4H)(filter.facet, null, facetLabels), ":").concat(filtervalue));
            });
        });
        const myIndex = dataLayerFilterArray.indexOf("".concat(facetName, ":").concat(objDisplay));
        if (myIndex !== -1) {
            dataLayerFilterArray.splice(myIndex, 1);
        } else {
            dataLayerFilterArray.push("".concat(facetName, ":").concat(objDisplay));
        }
        return dataLayerFilterArray.length ? dataLayerFilterArray.join("|") : "";
    };
    const plpFilterArrayData = getAppliedFiltersForPlpAnalyticsData(obj.display);
    let analyticsData = "";
    const appliedOrRemoved = isSelected(obj) ? "removed" : "applied";
    if (page === "search") {
        analyticsData = JSON.stringify({
            eventAction: "search results:".concat(selectedTab, ":filters ").concat(isSelected(obj) ? "removed" : "applied"),
            eventName: "search results:".concat(selectedTab, ":filters ").concat(isSelected(obj) ? "removed" : "applied"),
            eventType: "navigation",
            eventMsg: "n/a",
            eventStatus: "n/a",
            internalLinkName: "".concat(obj.display),
            internalLinkPosition: "search results",
            internalLinkType: "search results:".concat(facetName),
            internalLinkZoneName: "search results:".concat(selectedTab, ":filters"),
            internalLinkURL: "n/a",
            clickInternalLinks: "true",
            filterArray: plpFilterArrayData
        });
    } else if (page === "technicalspecs") {
        analyticsData = JSON.stringify({
            eventAction: "technical specs:filters ".concat(appliedOrRemoved),
            eventName: "technical specs:filters ".concat(appliedOrRemoved),
            eventType: "navigation",
            eventMsg: "n/a",
            eventStatus: "n/a",
            internalLinkName: "".concat(obj.display, ":").concat(appliedOrRemoved),
            internalLinkPosition: "technical specs",
            internalLinkType: "technical specs:".concat(facetName),
            internalLinkZoneName: "technical specs:filters",
            internalLinkURL: "n/a",
            clickInternalLinks: "true",
            filterArray: plpFilterArrayData
        });
    } else if (page === "article") {
        analyticsData = JSON.stringify({
            eventAction: "support:help and faq:filters:filter ".concat(appliedOrRemoved),
            eventName: "support:help and faq:filters:filter ".concat(appliedOrRemoved),
            eventType: "navigation",
            eventMsg: "n/a",
            eventStatus: "n/a",
            internalLinkName: "".concat(obj.display, ":").concat(appliedOrRemoved),
            internalLinkPosition: "knowledge articles",
            internalLinkType: "support:help and faq:".concat(facetName),
            internalLinkZoneName: "support:help and faq:filters",
            internalLinkURL: "n/a",
            clickInternalLinks: "true",
            filterArray: plpFilterArrayData
        });
    } else if (page === "literature") {
        analyticsData = JSON.stringify({
            eventAction: "literature :filters ".concat(isSelected(obj) ? "removed" : "applied"),
            eventName: "literature :filters ".concat(isSelected(obj) ? "removed" : "applied"),
            eventType: "navigation",
            eventMsg: "n/a",
            eventStatus: "n/a",
            internalLinkName: "".concat(obj.display.toLowerCase(), " :").concat(isSelected(obj) ? "removed" : "applied"),
            internalLinkPosition: "literature",
            internalLinkType: "literature:".concat(facetName.toLowerCase()),
            internalLinkZoneName: "literature:filters",
            internalLinkURL: "n/a",
            clickInternalLinks: "true",
            filterArray: plpFilterArrayData.toLowerCase()
        });
    } else {
        analyticsData = JSON.stringify({
            eventAction: "plp filter ".concat(isSelected(obj) ? "removed" : "applied"),
            eventName: "plp filter ".concat(isSelected(obj) ? "removed" : "applied"),
            eventType: "navigation",
            eventMsg: "n/a",
            eventStatus: "n/a",
            internalLinkName: "".concat(obj.display),
            internalLinkPosition: "plp",
            internalLinkType: "plp:".concat(facetName),
            internalLinkZoneName: "plp:filters",
            internalLinkURL: "n/a",
            clickInternalLinks: "true",
            filterArray: "".concat(plpFilterArrayData)
        });
    }
    return analyticsData;
};
const addFilterCancelDataLayerOnClick = function(value, appliedFilters, facet, filter, selectedTab, page) {
    let facetLabels = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : [];
    const filterArrayList = getAppliedFiltersForPlpAnalyticsData(appliedFilters, facet.facet, filter, facetLabels);
    let type = "plp filter ";
    let internalLinkPosition = "plp";
    let internalValue = "plp";
    let internalLinkName = filter;
    if (page === "article") {
        type = "support:help and faq:filters:";
        internalLinkPosition = "knowledge articles";
        internalValue = "support:help and faq";
        internalLinkName = "".concat(filter, ":removed");
    } else if (page === "search") {
        type = "search results:".concat(selectedTab, ":filters ");
        internalLinkPosition = "search results";
        internalValue = "search results:".concat(selectedTab);
    } else if (page === "technicalspecs") {
        type = "technical specs:filter ";
        internalLinkPosition = "technical specs";
        internalValue = "technical specs";
        internalLinkName = "".concat(filter, ":removed");
    }
    const eventValue = "".concat(type).concat(value).toLowerCase();
    const eventInfo = {
        eventAction: eventValue,
        eventName: eventValue,
        eventType: "navigation",
        filterArray: filterArrayList,
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: internalLinkName.toLowerCase(),
        internalLinkPosition: internalLinkPosition.toLowerCase(),
        internalLinkType: "".concat(internalValue, ":").concat((0,helper/* formatFacetName */.n4H)(facet["facet"], null, facetLabels)).toLowerCase(),
        internalLinkZoneName: "".concat(internalValue, ":filters").toLowerCase(),
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    };
    (0,helper/* pushAnalyticsObjToDataLayer */.zYT)(eventInfo);
};
const getAppliedFiltersForPlpAnalyticsData = function(appliedFilters, facet, obj) {
    let facetLabels = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : [];
    const dataLayerFilterArray = [];
    appliedFilters.forEach((filter)=>{
        filter.display.forEach((filtervalue)=>{
            dataLayerFilterArray.push("".concat((0,helper/* formatFacetName */.n4H)(filter.facet, null, facetLabels), ":").concat(filtervalue).toLowerCase());
        });
    });
    const myIndex = dataLayerFilterArray.indexOf("".concat((0,helper/* formatFacetName */.n4H)(facet, null, facetLabels), ":").concat(obj).toLowerCase());
    if (myIndex !== -1) {
        dataLayerFilterArray.splice(myIndex, 1);
    } else {
        dataLayerFilterArray.push("".concat((0,helper/* formatFacetName */.n4H)(facet, null, facetLabels), ":").concat(obj).toLowerCase());
    }
    return dataLayerFilterArray.length ? dataLayerFilterArray.join("|") : "";
};
const getFilterClearAllAnalyticsData = (sectionTab, page)=>{
    let analyticsData = {
        eventAction: "plp clear all filter",
        eventName: "plp clear all filter",
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "clear all",
        internalLinkPosition: "plp",
        internalLinkType: "plp:clear all",
        internalLinkZoneName: "plp:filters",
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    };
    if (page === "article") {
        analyticsData = {
            eventAction: "support:help and faq:filters​:clear all",
            eventName: "support:help and faq:filters​:clear all",
            eventType: "informative",
            eventMsg: "n/a",
            eventStatus: "n/a",
            internalLinkName: "clear all",
            internalLinkPosition: "knowledge articles",
            internalLinkType: "support:help and faq:navigation",
            internalLinkZoneName: "support:help and faq:filters​​",
            internalLinkURL: "n/a",
            clickInternalLinks: "true"
        };
    }
    if (page === "search") {
        analyticsData = {
            clickInternalLinks: "true",
            eventAction: "search results:".concat(sectionTab, ":clear all"),
            eventName: "search results:".concat(sectionTab, ":clear all"),
            eventType: "navigation",
            eventMsg: "n/a",
            eventStatus: "n/a",
            internalLinkName: "clear all",
            internalLinkPosition: "search results",
            internalLinkType: "search results:clear all",
            internalLinkURL: "n/a",
            internalLinkZoneName: "search results:".concat(sectionTab, ":filters")
        };
    }
    if (page === "literature") {
        analyticsData = {
            clickInternalLinks: "true",
            eventAction: "literature:filters:clear all",
            eventName: "literature:filters:clear all",
            eventType: "navigation",
            eventMsg: "n/a",
            eventStatus: "n/a",
            internalLinkName: "clear all",
            internalLinkPosition: "literature",
            internalLinkType: "literature:clear all",
            internalLinkURL: "n/a",
            internalLinkZoneName: "literature:filters"
        };
    }
    return JSON.stringify(analyticsData);
};
const getAnalyticsData = (isUnchecked)=>{
    const hideDiscontinuedEventObj = {
        eventAction: "search results:technical:filters​:hide discontinued products",
        eventName: "search results:technical:filters​:hide discontinued products",
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "hide discontinued products:".concat(isUnchecked ? "unchecked" : "checked"),
        internalLinkPosition: "search results",
        internalLinkType: "search results:checkbox",
        internalLinkZoneName: "search results:technical:filters",
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    };
    return JSON.stringify(hideDiscontinuedEventObj);
};
const getPrintOrShareEventInfo = (printOrShare, selectedTab, page)=>{
    let analyticsData = "";
    if (page === "search") {
        analyticsData = {
            eventAction: "search results:".concat(selectedTab, ":filters:").concat(printOrShare),
            eventName: "search results:".concat(selectedTab, ":filters:").concat(printOrShare),
            eventType: "navigation",
            eventMsg: "n/a",
            eventStatus: "n/a",
            internalLinkName: printOrShare,
            internalLinkPosition: "search results",
            internalLinkType: "search results:".concat(printOrShare),
            internalLinkZoneName: "search results:".concat(selectedTab, ":filters"),
            internalLinkURL: "n/a",
            clickInternalLinks: "true"
        };
    } else if (page === "technicalspecs") {
        analyticsData = {
            eventAction: "technical specs:filters:".concat(printOrShare),
            eventName: "technical specs:filters:".concat(printOrShare),
            eventType: "navigation",
            eventMsg: "n/a",
            eventStatus: "n/a",
            internalLinkName: printOrShare,
            internalLinkPosition: "tech specs",
            internalLinkType: "technical specs:".concat(printOrShare),
            internalLinkZoneName: "technical specs:filters​",
            internalLinkURL: "n/a",
            clickInternalLinks: "true"
        };
    } else if (page === "literature") {
        analyticsData = {
            eventAction: "literature:filters:".concat(printOrShare),
            eventName: "literature:filters:".concat(printOrShare),
            eventType: "navigation",
            eventMsg: "n/a",
            eventStatus: "n/a",
            internalLinkName: printOrShare,
            internalLinkPosition: "literature",
            internalLinkType: "literature:".concat(printOrShare),
            internalLinkZoneName: "literature:filters",
            internalLinkURL: "n/a",
            clickInternalLinks: "true"
        };
    } else {
        analyticsData = {
            eventAction: "plp ".concat(printOrShare),
            eventName: "plp ".concat(printOrShare),
            eventType: "navigation",
            eventMsg: "n/a",
            eventStatus: "n/a",
            internalLinkName: printOrShare,
            internalLinkPosition: "support:help and faq",
            internalLinkType: "support:help and faq:print",
            internalLinkZoneName: "support:help and faq:filters",
            internalLinkURL: "n/a",
            clickInternalLinks: "true"
        };
    }
    return JSON.stringify(analyticsData);
};
const getFilterCloseAnalyticsData = (page)=>{
    let analyticsData = "";
    if (page === "article") {
        analyticsData = '{"eventAction":"support:help and faq:filters​:close","eventName":"support:help and faq:filters​:close","eventType":"informative","eventMsg":"n/a","eventStatus":"n/a","internalLinkName":"close(x)","internalLinkPosition":"knowledge articles","internalLinkType":"support:help and faq:close","internalLinkZoneName":"support:help and faq:filters​","internalLinkURL":"n/a","clickInternalLinks":"true"}';
    } else {
        analyticsData = '{"eventAction":"plp filter close","eventName":"plp filter close","eventType":"informative","eventMsg":"n/a","eventStatus":"n/a","internalLinkName":"close","internalLinkPosition":"plp","internalLinkType":"plp:close","internalLinkZoneName":"plp:filters","internalLinkURL":"n/a","clickInternalLinks":"true"}';
    }
    return analyticsData;
};
const getFilterViewResultsAnalyticsData = (facetLabels, page, appliedFilters)=>{
    let analyticsData = "";
    if (page === "article") {
        analyticsData = '{"eventAction":"support:help and faq:filters​:view results","eventName":"support:help and faq:filters​:view results","eventType":"informative","eventMsg":"n/a","eventStatus":"n/a","internalLinkName":"view results","internalLinkPosition":"knowledge articles","internalLinkType":"support:help and faq:navigation","internalLinkZoneName":"support:help and faq:filters​","internalLinkURL":"n/a","clickInternalLinks":"true"}';
    } else {
        analyticsData = '{"eventAction":"plp filter view result","eventName":"plp filter view result","eventType":"informative","eventMsg":"n/a","eventStatus":"n/a","internalLinkName":"view result","internalLinkPosition":"plp","internalLinkType":"plp:filters","internalLinkZoneName":"plp:filters","internalLinkURL":"n/a","clickInternalLinks":"true","filterArray":"' + getAppliedFiltersForAnalytics(appliedFilters, facetLabels) + '"}';
    }
    return analyticsData;
};
const getFilterCloseImgAnalyticsData = ()=>{
    const analyticsData = '{"eventAction":"plp filter close","eventName":"plp filter close","eventType":"informative","eventMsg":"n/a","eventStatus":"n/a","internalLinkName":"close","internalLinkPosition":"close","internalLinkType":"plp:close","internalLinkZoneName":"plp:filters","internalLinkURL":"n/a","clickInternalLinks":"true"}';
    return analyticsData;
};
const getSocialShareAnalyticsData = (page, selectedTab)=>{
    let analyticsData = "";
    if (page === "technicalspecs") {
        analyticsData = {
            eventAction: "technical specs:filters:share",
            eventName: "technical specs:filters:share",
            internalLinkPosition: "tech specs",
            internalLinkType: "technical specs​:share",
            internalLinkZoneName: "technical specs:filters"
        };
    } else if (page === "search") {
        analyticsData = {
            eventAction: "search results:".concat(selectedTab, ":filters:share"),
            eventName: "search results:".concat(selectedTab, ":filters:share"),
            internalLinkPosition: "search results",
            internalLinkType: "search results:share",
            internalLinkZoneName: "search results:".concat(selectedTab, ":filters")
        };
    } else if (page === "literature") {
        analyticsData = {
            eventAction: "".concat(page, ":filters:share"),
            eventName: "".concat(page, ":filters:share"),
            internalLinkPosition: "".concat(page),
            internalLinkType: "".concat(page, ":share"),
            internalLinkZoneName: "".concat(page, ":filters")
        };
    } else {
        analyticsData = {
            eventAction: "plp share",
            eventName: "plp share",
            internalLinkPosition: "support:help and faq",
            internalLinkType: "support:help and faq:share",
            internalLinkZoneName: "support:help and faq:filters"
        };
    }
    return analyticsData;
};


;// CONCATENATED MODULE: ./components/ProductList/v2/Filter/collapsibleFacet.jsx






const CollapsibleFacet = (param)=>{
    let { facets , filterTitle , page , type ="" , appliedFilters , loading , onChange , isSelected , facetLabels , selectedTab , colors , showFilter , isAnnsacksPlp =false  } = param;
    const [collapse, setCollapse] = (0,react.useState)({});
    const facet = facets[0];
    const facetList = facets[1];
    const facetName = (0,helper/* formatFacetName */.n4H)(facets[0], null, facetLabels);
    const facetCount = facets[1].length / 2;
    const [isInspirationPage, setIsInspirationPage] = (0,react.useState)(false);
    const handleCollapse = (state)=>{
        setCollapse({
            [facet]: state
        });
    };
    (0,react.useEffect)(()=>{
        const slugName = window.location.pathname.split("/").pop();
        if (slugName === "inspiration-by-collection") {
            setIsInspirationPage(true);
        }
    }, []);
    (0,react.useEffect)(()=>{
        if (appliedFilters.length > 0) {
            setCollapse((prevCollapse)=>{
                const nextCollapse = {
                    ...prevCollapse
                };
                appliedFilters.forEach((obj)=>{
                    var ref;
                    if (obj === null || obj === void 0 ? void 0 : (ref = obj.value) === null || ref === void 0 ? void 0 : ref.length) {
                        nextCollapse[obj.facet] = true;
                    }
                });
                return nextCollapse;
            });
        } else {
            setCollapse({});
        }
    }, [
        appliedFilters,
        showFilter
    ]);
    const handleOnChange = (event, obj)=>{
        var ref;
        onChange((ref = event.target) === null || ref === void 0 ? void 0 : ref.checked, obj);
        try {
            const { adobeDataLayer: { getState  } = {}  } = window;
            const pageEvent = getState && getState("page") || {};
            const eventInfo = JSON.parse(getFilterOptionsAnalyticsData({
                obj,
                appliedFilters,
                facetLabels,
                facetName,
                isSelected,
                page,
                selectedTab
            }) || "{}");
            window.adobeDataLayer.push({
                event: "cmp:click",
                page: pageEvent,
                eventInfo
            });
        } catch (err) {
            console.log(err);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Collapsible/* default */.Z, {
        tabIndex: "0",
        open: collapse[facet] && showFilter ? true : false,
        onTriggerOpening: ()=>handleCollapse(true),
        onTriggerClosing: ()=>handleCollapse(false),
        openedClassName: "is-open",
        trigger: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            "aria-label": filterTitle(facetName, facetCount),
            "aria-expanded": collapse[facet] ? true : false,
            className: "gbh-data-layer",
            "data-gbh-data-layer": getShowHideFilterOptionAnalyticsData(collapse, facet, facetName, page, selectedTab),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    "aria-hidden": "true",
                    children: facetName
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                    className: "plus",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "line-1 line"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "line line-2"
                        })
                    ]
                })
            ]
        }),
        transitionTime: 400,
        easing: "ease-in-out",
        children: collapse[facet] && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                role: "list",
                className: "filter-list",
                children: facetList.map((filter, i, arr)=>{
                    if (i % 2 === 0) {
                        let displayText = null;
                        if (facet === "Price_Range") {
                            displayText = (0,helper/* formatPriceRange */.NO1)(filter, isAnnsacksPlp);
                        }
                        const obj = {
                            facet: facet,
                            value: filter,
                            display: displayText !== null && displayText !== void 0 ? displayText : filter
                        };
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            role: "listitem",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                                role: "checkbox",
                                "aria-checked": "false",
                                id: facet + filter,
                                disabled: loading,
                                checkBoxAria: facet === "Price_Range" ? obj.display : "".concat(obj.display, " (").concat(arr[i + 1], ") Selecting this checkbox will update the ").concat(obj.display, " ").concat(facetName, " products"),
                                tabIndex: collapse[facet] ? 0 : -1,
                                value: facet === "Price_Range" ? obj.display : "".concat(obj.display, " (").concat(arr[i + 1], ")"),
                                onChange: (e)=>handleOnChange(e, obj),
                                checked: isSelected(obj),
                                swatch: (0,helper/* isColorFacet */.B3G)(facet) ? colors[filter] : null
                            }, filter)
                        }, facet + filter);
                    }
                })
            })
        })
    });
};
/* harmony default export */ var collapsibleFacet = (CollapsibleFacet);

// EXTERNAL MODULE: ./node_modules/lodash/cloneDeep.js
var cloneDeep = __webpack_require__(50361);
var cloneDeep_default = /*#__PURE__*/__webpack_require__.n(cloneDeep);
// EXTERNAL MODULE: ./components/SocialShare/v1/SocialShare.jsx + 1 modules
var SocialShare = __webpack_require__(24636);
// EXTERNAL MODULE: ./public/icons/filter.svg
var filter = __webpack_require__(24495);
;// CONCATENATED MODULE: ./src/components/ProductList/v2/Filter/index.jsx


















const Filter = (props)=>{
    const { showFilter =false , selectedSort ={} , facetLabels =[] , totalResults =0 , hidePriceRange , loading , discontinuedCheck , displayPrint =false , displayShare =false , facetData =[] , sort =[] , showSort =false , onSortChange =()=>{} , texts: { filterSort ="" , clearAll ="" , filters ="" , selected ="" , sortByAria ="" , sort: sortText = "" , filterTitle =()=>{} , discontinuedText ="" , hideDiscontinued ="" , arialLabelPrint =()=>{} , print ="" , ariaLabelShare =()=>{} , share ="" , view ="" , results =""  } , colors ={} , addToUrl =false , onFilter =()=>{} , handleScroll =()=>{} , page ="" , currFilters , isReplace , resetTitle , type ="" , close =()=>{} , isSearchTab , isAnnsacksPlp =false , isFaq =false , wrapperClass =".product-listing__tile" , actions =[] , needHelpLabel ="" , isAsLiterature =false  } = props;
    const router = (0,next_router.useRouter)();
    const [width] = (0,useWindowResize/* default */.Z)();
    const plpFilter = (0,react.useRef)(null);
    const [appliedFilters, setAppliedFilters] = (0,react.useState)([]);
    const [showSocialLink, setShowSocialLink] = (0,react.useState)(false);
    const [scrollInstance, setScrollInstance] = (0,react.useState)(null);
    const sortBy = (0,react.useRef)();
    const socialShareREf = (0,react.useRef)();
    const selectedTab = type || "products";
    (0,react.useEffect)(()=>{
        if (currFilters && currFilters.length > 0) {
            setAppliedFilters(currFilters);
        } else {
            setAppliedFilters([]);
        }
    }, [
        currFilters
    ]);
    (0,react.useEffect)(()=>{
        var ref;
        (ref = window.wow) === null || ref === void 0 ? void 0 : ref.sync();
        const instance = window.OverlayScrollbars ? window.OverlayScrollbars(plpFilter === null || plpFilter === void 0 ? void 0 : plpFilter.current, {
            className: "os-theme-dark os-host-flexbox",
            resize: "none",
            sizeAutoCapable: true,
            clipAlways: true,
            normalizeRTL: true,
            paddingAbsolute: false,
            autoUpdate: null,
            autoUpdateInterval: 33,
            nativeScrollbarsOverlaid: {
                showNativeScrollbars: false,
                initialize: true
            },
            overflow: {
                x: "hidden"
            },
            scrollbars: {
                visibility: "auto",
                autoHide: "never",
                autoHideDelay: 800,
                dragScrolling: true,
                clickScrolling: true,
                touchSupport: true,
                snapHandle: true
            }
        }) : null;
        setScrollInstance(instance);
    }, []);
    let filterList = {
        ...facetData
    };
    delete filterList["New_Products"];
    delete filterList["Hide_Discontinued"];
    delete filterList["Products"];
    delete filterList["Inspiration"];
    delete filterList["Technical"];
    delete filterList["Parts"];
    delete filterList["Help"];
    delete filterList["Resource"];
    if (hidePriceRange) {
        delete filterList["Price_Range"];
    } else if (filterList["Price_Range"] && router.locale === "fr") {
        filterList = {
            "priceList.ANY.finalPrice_d": filterList["Price_Range"],
            ...filterList
        };
        delete filterList["Price_Range"];
    } else if (filterList["Price_Range"]) {
        filterList = {
            Price_Range: filterList["Price_Range"],
            ...filterList
        };
    }
    const facets = Object.entries(filterList).filter((facet)=>facet[1].length > 0);
    const handleFilter = (checked, obj)=>{
        let curFilters = cloneDeep_default()(appliedFilters);
        const facet = curFilters.find((filter)=>filter.facet === obj.facet);
        if (checked) {
            if (facet) {
                facet.value.push(obj.value.replace(/"/g, '\\"'));
                facet.display.push(obj.display);
            } else curFilters.push({
                facet: obj.facet,
                value: [
                    obj.value.replace(/"/g, '\\"')
                ],
                display: [
                    obj.display
                ]
            });
        } else {
            const index = facet.display.indexOf(obj.display);
            facet.value.splice(index, 1);
            facet.display.splice(index, 1);
            if (!facet.value.length) {
                curFilters = curFilters.filter((f)=>f.facet !== obj.facet);
            }
        }
        (0,helper/* resetFilterUrl */.pUm)();
        setAppliedFilters([
            ...curFilters
        ]);
        addToUrl && setUrlParams(curFilters, isReplace, isFaq ? "" : type, facetLabels, resetTitle, clearAllFilters);
        onFilter(curFilters);
        handleScroll && handleScroll();
    };
    const clearAllFilters = function() {
        let isOnFilter = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
        setAppliedFilters([]);
        isOnFilter && onFilter([]);
        (0,helper/* resetFilterUrl */.pUm)();
        if (resetTitle) resetTitle();
        if (type) (0,helper/* retainSearchQueryParams */.mSA)(type);
    };
    const printPlp = ()=>{
        scrollToAllProduct();
        setTimeout(()=>{
            window.print();
        }, 1250);
    };
    const scrollToAllProduct = ()=>{
        const scorllObjInterval = setInterval(()=>{
            const scrollPositions = document.querySelectorAll("".concat(wrapperClass, " div.LazyLoad:not(.is-visible)"));
            if (scrollPositions.length > 0) {
                scrollPositions[0].scrollIntoView({
                    behavior: "smooth",
                    block: "start",
                    inline: "nearest"
                });
            } else {
                clearInterval(scorllObjInterval);
            }
        }, 150);
        setTimeout(()=>{
            clearInterval(scorllObjInterval);
        }, 2000);
    };
    const handleShare = (e)=>{
        e.stopPropagation();
        e.preventDefault();
        setShowSocialLink(!showSocialLink);
        setTimeout(()=>{
            const shareEl = socialShareREf.current;
            scrollInstance === null || scrollInstance === void 0 ? void 0 : scrollInstance.scroll({
                el: shareEl,
                block: "center"
            }, 500);
        }, 100);
        try {
            var ref, ref1;
            const { adobeDataLayer: { getState  } = {}  } = window;
            const eventInfo = JSON.parse((e === null || e === void 0 ? void 0 : (ref = e.target) === null || ref === void 0 ? void 0 : (ref1 = ref.dataset) === null || ref1 === void 0 ? void 0 : ref1.gbhDataLayer) || "{}");
            const page = getState && getState("page") || {};
            window.adobeDataLayer.push({
                event: "cmp:click",
                page,
                eventInfo
            });
        } catch (err) {
        // console.log(err)
        }
    };
    const isSelected = (obj)=>{
        const facet = appliedFilters.find((filter)=>filter.facet === obj.facet);
        if (!facet) return false;
        return facet.display.includes(obj.display) || facet.display.includes(obj.display.replaceAll(" ", "+"));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        ref: plpFilter,
        className: classnames_default()("product-listing filter"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "filter__inner-container",
                children: [
                    !isSearchTab && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "product-listing__controls filter__mobile-header",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "product-listing__filter-toggle gbh-data-layer",
                                "data-gbh-data-layer": getFilterCloseAnalyticsData(page),
                                children: isAsLiterature ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            src: filter/* default */.Z === null || filter/* default */.Z === void 0 ? void 0 : filter/* default.src */.Z.src,
                                            className: "product-list__filter-toggle-icon",
                                            alt: "Toggle Filter"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                            children: [
                                                props.texts.filters,
                                                " ",
                                                props.selectedFilterCount > 0 && " (".concat(props.selectedFilterCount, ")")
                                            ]
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: filterSort
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                tabIndex: "0",
                                role: "button",
                                src: close_filter/* default */.Z === null || close_filter/* default */.Z === void 0 ? void 0 : close_filter/* default.src */.Z.src,
                                className: "product-listing__close-icon gbh-data-layer",
                                "data-gbh-data-layer": getFilterCloseImgAnalyticsData(),
                                alt: "Close Filter",
                                onClick: ()=>close(false)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "filter__chips",
                        children: [
                            appliedFilters.map((facet)=>{
                                return facet.display.map((filter)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "filter__chips-tag",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                children: [
                                                    " ",
                                                    filter === "Yes" || filter === "No" || !isNaN(parseInt(filter)) ? (0,helper/* formatFacetName */.n4H)(facet["facet"], filter, facetLabels) : filter.replaceAll("+", " ")
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                src: close_filter/* default */.Z,
                                                tabIndex: "0",
                                                role: "button",
                                                "aria-label": "Remove filter ".concat(filter === "Yes" || filter === "No" ? (0,helper/* formatFacetName */.n4H)(facet["facet"], filter, facetLabels) : filter),
                                                alt: "close Icon",
                                                className: "filter__chips-close-icon gbh-data-layer",
                                                onClick: ()=>{
                                                    handleFilter(false, {
                                                        facet: facet.facet,
                                                        display: filter
                                                    });
                                                    addFilterCancelDataLayerOnClick("cancel", appliedFilters, facet, filter, selectedTab, page, facetLabels);
                                                }
                                            })
                                        ]
                                    }, filter));
                            }),
                            appliedFilters.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "filter__chips-clear-all gbh-data-layer",
                                tabIndex: "0",
                                role: "button",
                                "aria-label": "".concat(clearAll, " ").concat(filters),
                                "data-gbh-data-layer": getFilterClearAllAnalyticsData(selectedTab, page),
                                onClick: clearAllFilters,
                                children: clearAll
                            })
                        ]
                    }),
                    showSort && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "filter__mobile-sort",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            role: "radiogroup",
                            "aria-labelledby": "sortBy-radio",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                    id: "sortBy-radio",
                                    className: "filter__mobile-sort-title",
                                    "aria-label": selectedSort ? "".concat(selectedSort.name, " ").concat(selected) : sortByAria,
                                    children: "".concat(sortText, " ").concat(selectedSort ? ": " + selectedSort.name : "")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "radio-wrapper",
                                    ref: sortBy,
                                    children: sort.map((item, i)=>{
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(RadioButton/* default */.Z, {
                                            id: "sort-by-".concat(item.name),
                                            name: "sort-by",
                                            value: item.name,
                                            checked: item.name === (selectedSort === null || selectedSort === void 0 ? void 0 : selectedSort.name),
                                            onClick: ()=>onSortChange(item)
                                        }, i);
                                    })
                                })
                            ]
                        })
                    }),
                    totalResults > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        role: "list",
                        className: "filter__filter-list",
                        children: facets.map((facet)=>{
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "collapsible-outer",
                                role: "listitem",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(collapsibleFacet, {
                                    facets: facet,
                                    showFilter: showFilter,
                                    facetLabels: facetLabels,
                                    filterTitle: filterTitle,
                                    appliedFilters: appliedFilters,
                                    loading: loading,
                                    onChange: handleFilter,
                                    isSelected: isSelected,
                                    colors: colors,
                                    selectedTab: selectedTab,
                                    page: page,
                                    type: type,
                                    isAnnsacksPlp: isAnnsacksPlp
                                })
                            }, facet);
                        })
                    }),
                    discontinuedCheck && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "filter__hide-discontinued",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                                id: "discontinued",
                                onChange: (e)=>handleFilter(e.target.checked, {
                                        facet: "Hide_Discontinued",
                                        value: "true",
                                        display: discontinuedText
                                    }),
                                checked: isSelected({
                                    facet: "Hide_Discontinued",
                                    value: "true",
                                    display: discontinuedText
                                }),
                                value: hideDiscontinued,
                                analyticsData: getAnalyticsData(isSelected({
                                    facet: "Hide_Discontinued",
                                    value: "true",
                                    display: discontinuedText
                                }))
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "filter__print-and-share",
                        children: [
                            displayPrint !== undefined && displayPrint && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                tabIndex: "0",
                                role: "button",
                                "aria-label": arialLabelPrint(page),
                                className: "gbh-data-layer",
                                hidden: width < 992,
                                "data-gbh-data-layer": getPrintOrShareEventInfo("print", selectedTab, page),
                                onClick: ()=>printPlp(),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: icons_print/* default */.Z === null || icons_print/* default */.Z === void 0 ? void 0 : icons_print/* default.src */.Z.src,
                                        alt: "print-icon",
                                        role: "presentation"
                                    }),
                                    print
                                ]
                            }),
                            displayShare !== undefined && displayShare && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                tabIndex: "0",
                                role: "button",
                                "aria-label": ariaLabelShare(page),
                                className: "gbh-data-layer",
                                hidden: width < 992,
                                "data-gbh-data-layer": getPrintOrShareEventInfo("share", selectedTab, page),
                                "aria-expanded": showSocialLink ? true : false,
                                onClick: handleShare,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: icons_share/* default */.Z === null || icons_share/* default */.Z === void 0 ? void 0 : icons_share/* default.src */.Z.src,
                                        alt: "share-icon",
                                        role: "presentation"
                                    }),
                                    share
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SocialShare/* default */.Z, {
                        showModal: showSocialLink,
                        id: "kf-plp-filter",
                        onClose: ()=>setShowSocialLink(false),
                        analyticData: getSocialShareAnalyticsData(page, selectedTab),
                        shareRef: socialShareREf
                    }),
                    needHelpLabel || actions.length ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "filter__need-help-container",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "need-help-label",
                                children: needHelpLabel
                            }),
                            actions.length ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                children: actions.map((action, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "need-help-links-container",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            className: "need-help-link",
                                            href: action.url ? action.url.replace("/content/annsacks/us/en", "").replace(".html", "") : "",
                                            children: action.title
                                        })
                                    }, "fra32a-44s-".concat(index, "342-dag32f")))
                            }) : null
                        ]
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "filter__footer",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                    className: classnames_default()("filter__apply gbh-data-layer"),
                    "data-gbh-data-layer": getFilterViewResultsAnalyticsData(facetLabels, page, appliedFilters),
                    onClick: ()=>close(false),
                    children: [
                        loading && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "filter__apply-loader"
                        }),
                        "".concat(view, " ").concat(results, " (").concat(totalResults, ")")
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var v2_Filter = (Filter);


/***/ })

}]);